import { extendedDrawerWidth } from '@/components/Drawer/styles'
import { ColorEnum } from '@/constants/color'
import { shortenProfileName } from '@/features/auth/utils/shortenProfileName'
import PersonBubble from '@/features/common/components/PersonBubble'
import { MenuItem } from '@/features/ui/navigation'
import { DrawerItem } from '@react-navigation/drawer'
import { router, usePathname } from 'expo-router'
import { FC } from 'react'

interface ExtendedDrawerCurrentProfileActionProps {
    profileName: string
}

const ExtendedDrawerCurrentProfileAction: FC<ExtendedDrawerCurrentProfileActionProps> = ({
    profileName,
}) => {
    const pathname = usePathname()

    const focused = pathname === '/auth/profile-active-session'

    const handlePress = () => {
        if (focused) return

        router.replace('/auth/profile-active-session')
    }

    return (
        <DrawerItem
            focused={focused}
            activeBackgroundColor={ColorEnum.Transparent}
            activeTintColor={ColorEnum.BRICK_500}
            inactiveTintColor={ColorEnum.WHITE}
            label={() => (
                <MenuItem
                    Icon={({ size }) => <PersonBubble width={size} height={size} />}
                    label={shortenProfileName(profileName)}
                    active={focused}
                    style={{ width: extendedDrawerWidth, marginVertical: -15, marginLeft: -16 }}
                />
            )}
            onPress={handlePress}
            style={{ overflow: 'visible' }}
        />
    )
}

export default ExtendedDrawerCurrentProfileAction
